import { isPresent } from "@suse-o11y/is-present";
import type { LegacyRef, MutableRefObject, RefCallback } from "react";
import reactMergeRefs from "react-merge-refs";

export function mergeRefs<T>(refs: Array<null | undefined | MutableRefObject<T> | LegacyRef<T>>): RefCallback<T> {
	return reactMergeRefs(refs.filter(isPresent));
}
